import React from 'react'
import './style.css'

const Container = (props) => (
    <div className="container container-custom" >
        <div className="columns">
            <div className="column">
                {props.children}
            </div>
        </div>
    </div >
)

export { Container }
